/**
 * CR-7714: shown when the site's OTIF window could not be loaded for this
 * request. Helix does not judge a schedule on a substitute window, so those
 * rows carry no verdict and the Passed / Failed / Pending views leave them
 * out. This says so, rather than letting the list look complete.
 */
import { AlertTriangle } from 'lucide-react';

export const OTIF_WINDOW_UNAVAILABLE_TEXT =
  "This site's OTIF window could not be loaded, so schedules without a window of their own are not judged. They show as Not judged and are left out of Passed, Failed and Pending. Reload the page; if this stays, check Admin Setup → Performance.";

export function OtifWindowUnavailableNote({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="otif-window-unavailable-note"
      className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{OTIF_WINDOW_UNAVAILABLE_TEXT}</span>
    </div>
  );
}
